"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _IssueStageProgressBar = _interopRequireDefault(require("@common/components/issues/IssueStageProgressBar"));
var _badge = require("@design/ui/badge");
var _card = require("@design/ui/card");
var _checkbox = require("@design/ui/checkbox");
var _utils = require("@design/lib/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var CLICKABLE_STAGES = new Set(["done", "remedy", "error", "in-progress", "skipped"]);
var STAGE_BADGES = {
  error: {
    label: "Failed",
    Icon: _materialSymbols.ErrorIcon,
    variant: "destructive"
  },
  skipped: {
    label: "Not run",
    Icon: _materialSymbols.DoNotDisturbOnIcon,
    variant: "secondary"
  }
};
function IssueCard(_ref) {
  var issue = _ref.issue,
    onClick = _ref.onClick,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    onSelectionChange = _ref.onSelectionChange,
    _ref$showCheckbox = _ref.showCheckbox,
    showCheckbox = _ref$showCheckbox === void 0 ? false : _ref$showCheckbox,
    filteredIndex = _ref.filteredIndex;
  var isClickable = CLICKABLE_STAGES.has(issue.stage);
  function handleClick() {
    if (!isClickable) return;
    var indexToUse = filteredIndex !== undefined ? filteredIndex : issue.index;
    onClick === null || onClick === void 0 || onClick(indexToUse, issue.index);
  }
  function handleCheckedChange(checked) {
    if (issue.ruleUuid && onSelectionChange) {
      onSelectionChange(issue.ruleUuid, checked === true);
    }
  }
  function handleKeyDown(e) {
    if (!isClickable) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleClick();
    }
  }
  var badge = STAGE_BADGES[issue.stage];
  var stageBadge = badge ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_badge.Badge, {
    variant: badge.variant,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(badge.Icon, {
      "data-icon": "inline-start"
    }), badge.label]
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.Card, {
    size: "sm",
    onClick: handleClick,
    role: isClickable ? "button" : "group",
    tabIndex: isClickable ? 0 : -1,
    "aria-disabled": !isClickable,
    "aria-label": "".concat(issue.name, " \u2014 ").concat(issue.importance, " importance \u2014 ").concat(issue.stage.replace("-", " ")),
    onKeyDown: handleKeyDown,
    className: (0, _utils.cn)("relative transition-all duration-300 ease-out active:translate-y-0.5", isClickable ? "cursor-pointer" : "cursor-default"),
    "data-sentry-element": "Card",
    "data-sentry-component": "IssueCard",
    "data-sentry-source-file": "IssueCard.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IssueStageProgressBar.default, {
      stage: issue.stage,
      importance: issue.importance,
      match: issue.match,
      responded: issue.responded,
      conceded: issue.conceded,
      "data-sentry-element": "IssueStageProgressBar",
      "data-sentry-source-file": "IssueCard.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.CardHeader, {
      "data-sentry-element": "CardHeader",
      "data-sentry-source-file": "IssueCard.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.CardTitle, {
        className: "flex min-w-0 items-center gap-3",
        "data-sentry-element": "CardTitle",
        "data-sentry-source-file": "IssueCard.tsx",
        children: [showCheckbox && /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkbox.Checkbox, {
          checked: isSelected,
          onCheckedChange: handleCheckedChange,
          "aria-label": "Select ".concat(issue.name),
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          onKeyDown: function onKeyDown(e) {
            return e.stopPropagation();
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "truncate",
          children: issue.name
        })]
      }), issue.description && /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardDescription, {
        className: "line-clamp-2",
        children: issue.description
      }), stageBadge && /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardAction, {
        children: stageBadge
      })]
    })]
  });
}
var _default = exports.default = IssueCard;